"use strict";

angular
  .module("programme")

  .factory(
    "programmeEditorOptions",
    function (editorDefaultOptions, extendDeep, $log) {
      var options = extendDeep(angular.copy(editorDefaultOptions), {
        nestableComponents: {
          editor: {
            components: {
              "comp-panel": "Panel",
              "quote-paragraph": "Quote & Paragraph",
              "inset-paragraph": "Inset & Paragraph",
              column: "Columns",
              gallery: "Gallery",
              well: "Well",
              "carousel-comp": "Carousel",
              "hero-shot": "Hero Shot",
              container: "Container",
              "player-list": "Player List",
              block: "Block",
              "key-moments": "Key Moments",
              kit: "Kit",
              "goal-list": "Goal List",
              navigation: "Navigation",
            },
          },
          "one-column": {
            nested: {
              heading: "Heading",
              subheading: "Sub-Heading",
              textblock: "Paragraph",
              bullets: "Bullets",
              well: "Well",
              image: "Image",
              "image-group": "Image Group",
              "video-player": "Video",
              table: "Table",
              "pub-tabs": "Tabs",
              collapsible: "Collapsible",
              "booking-item": "Booking-Item",
              "side-accordion": "Side-Accordion",
              calendar: "Calendar",
            },
          },
          "two-column": {
            nested: {
              heading: "Heading",
              subheading: "Sub-Heading",
              textblock: "Paragraph",
              bullets: "Bullets",
              well: "Well",
              image: "Image",
              "image-group": "Image Group",
              "video-player": "Video",
              table: "Table",
              "pub-tabs": "Tabs",
              collapsible: "Collapsible",
              "booking-item": "Booking-Item",
              calendar: "Calendar",
            },
          },
          well: {
            nested: {
              textblock: "Paragraph",
              bullets: "Bullets",
            },
          },
          column: {
            // Same as editor
          },
          table: {
            // Same as editor
          },
          "comp-panel": {
            // Same as editor
          },
          gallery: {
            components: {
              textblock: "Textblock",
            },
          },
          "inset-paragraph": {
            image: {
              image: "Image",
            },
          },
        },
        componentClasses: {
          image: {
            default: " ",
            classes: {
              " ": "Left align",
              "default-center": "Center align",
              "default-right": "Right align",
              "hero-shot": "Hero Shot",
              "image-border": "Border",
            },
          },
          gallery: {
            default: " ",
            classes: {
              " ": "Default",
            },
          },
          textblock: {
            default: " ",
            classes: {
              " ": "Normal",
              "bordered-top": "Bordered top",
              introduction: "Introduction",
              "first-paragraph": "First paragraph",
              "large-heading": "Large heading",
              "large-heading-bordered": "Large heading Bordered",
              "medium-introduction": "Medium introduction",
              "no-bottom-margin": "No bottom margin",
            },
          },
          "comp-panel": {
            default: " ",
            classes: {
              " ": "Transparent",
              container: "Container",
              "container-fluid": "Fluid container",
              "container container-narrow": "Narrow container",
              "container container-extra-narrow": "Extra narrow container",
              "container container-expanded": "Expanded container",
              "panel-circle": "Circle",
              "thick-black": "Thick black",
              "thin-yellow": "Thin yellow",
            },
          },
        },
        componentOptions: {
          "comp-panel": {
            defaultBackground: "#FFFFFF",
            templateUrl:
              "modules/programme/editor-components/compPanelOptions.html",
            margin: true,
            height: false,
            footnote: true,
          },
          gallery: {
            templateUrl:
              "modules/programme/editor-components/gallery/galleryOptions.html",
          },
          "inset-paragraph": {
            templateUrl:
              "modules/programme/editor-components/inset-paragraph/insetParagraphOptions.html",
          },
          "quote-paragraph": {
            templateUrl:
              "modules/programme/editor-components/quote-paragraph/quoteParagraphOptions.html",
          },
          "carousel-comp": {
            templateUrl:
              "modules/programme/editor-components/carousel/carouselOptions.html",
          },
          "player-list": {
            templateUrl:
              "modules/programme/editor-components/player-list/player-list.options.html",
          },
          column: {
            templateUrl:
              "modules/programme/editor-components/column/columnOptions.html",
          },
          block: {
            templateUrl:
              "modules/programme/editor-components/block/blockOptions.html",
          },
          "key-moments": {
            templateUrl:
              "modules/programme/editor-components/key-moments/keyMomentsOptions.html",
          },
          kit: {
            templateUrl:
              "modules/programme/editor-components/kit/kitOptions.html",
          },
          "carousel-video": {
            templateUrl:
              "modules/programme/editor-components/carousel-video/carouselVideoOptions.html",
          },
          "goal-list": {
            templateUrl:
              "modules/programme/editor-components/goal-list/goalListOptions.html",
          },
          "mobile-image": {
            templateUrl:
              "modules/programme/editor-components/mobile-image/mobileImageOptions.html",
          },
          image: {
            placeholderImage: "/images/white.png",
          },
          well: {
            margin: true,
          },
        },
        /**
         * Add some shortcut component names
         */
        backwardsCompatibility: {
          "hero-shot": function (model) {
            model.type = "mobile-image";
            model.class = "hero-shot";
            model.data.hasOverlay = true;

            model.overlay = [
              {
                type: "textblock",
                tag: "h2",
                html: "&nbsp; The",
              },
              {
                type: "textblock",
                tag: "h1",
                html: "Title",
              },
              {
                type: "textblock",
                tag: "p",
                html: "Something, something, footnote.",
              },
            ];
          },
          container: function (model) {
            model.type = "panel";
            model.class = "container";
          },
        },
        backgroundColors: {
          "#FFFFFF": "White",
          "#000000": "Black",
          "#041930": "Navy",
          "#F5F5F5": "Off White",
          "#AEB6BC": "RM Grey",
          "#FCBF00": "RM Gold",
          "#C31B22": "AM Red",
          "#22327A": "AM Royal Blue",
        },
        textColours: {
          White: "#FFFFFF",
          Black: "#000000",
          Navy: "#041930",
          Yellow: "#f8ae00",
          "Mid Blue": "#072B53",
          "Light Blue": "#009EE3",
        },
      });

      options.nestableComponents.table.nested =
        options.nestableComponents.editor.components;

      options.nestableComponents.column.components =
        options.nestableComponents.editor.components;
      options.nestableComponents.column.components.gallery = "Gallery";
      options.nestableComponents.column.components.block = "Block";
      options.nestableComponents.column.components["carousel-comp"] =
        "Carousel";
      options.nestableComponents.column.components.kit = "Kit";

      options.nestableComponents["comp-panel"].nested =
        options.nestableComponents.editor.components;
      options.nestableComponents["comp-panel"].nested.gallery = "Gallery";
      options.nestableComponents["comp-panel"].nested.block = "Block";
      options.nestableComponents["comp-panel"].nested["carousel-comp"] =
        "Carousel";
      options.nestableComponents["comp-panel"].kit = "Kit";

      $log.debug(options.nestableComponents);

      return options;
    }
  );
